import React from "react"
import { Helmet } from "react-helmet"
import { navigate } from "gatsby"

import SignIn from "../components/signin"

import useUser from "../hooks/useUser"

import styles from "../styles/logpage.module.css"


export default () => {
  const user = useUser()
  if(user){navigate("/")}
  return(
    <div className = {styles.body}>
    <div className = {styles.authForm}>
      <Helmet>
        <title>Char.ly</title>
        <link rel="icon" href="/static/icon.png" />
      </Helmet>
      <div className = {styles.title}>
        <p className= {styles.char}>Char<p className = {styles.dot}>.</p>ly</p>
      </div>
      <div className = {styles.tagline}><p>journal your feelings away</p></div>
      <SignIn/>
      <div className = {styles.link}>
      <a className = {styles.a} href = "/signup">Don't have an account? Create one here</a>
      </div>
      <div className = {styles.about}>
        <h2>What is Char.ly?</h2> 
        <p className = {styles.explanation}> 
Journaling is one of the key mediums to channel our inner self. Journal entries are a 
great way to either detect changes and cope with our mental health, such as 
Writing Therapy and sharing journal entries. </p>
        <p className = {styles.explanation}>With Char.ly, our users are presented with an interactive journaling interface 
that changes dynamically as the reader writes, returning short and long-term 
trends in journal entries while maintaining privacy of the actual journal 
contents. 
</p>
      </div>
      </div>
      </div>
  )
}